import styled from 'styled-components';
import { eventApi } from '../../../core/api/rtk-query/event.api';

const Backdrop = styled.div`position:fixed; inset:0; background:rgba(13,25,41,.36); display:flex; align-items:center; justify-content:center;`;
const Modal = styled.div`width:460px; max-width:calc(100% - 24px); background:#fff; border-radius:16px; border:1px solid #e5e8f0; box-shadow:0 16px 48px rgba(0,0,0,.08); padding:16px; display:grid; gap:12px;`;
const Row = styled.div`display:flex; gap:8px; align-items:center; justify-content:flex-end;`;
const Btn = styled.button`background:#fff; border:1px solid #dbe3f6; color:#0b1221; padding:8px 12px; border-radius:10px; cursor:pointer;`;

export const DeleteEventConfirm = ({ id, onClose }: { id: string; onClose: () => void }) => {
  const [remove, { isLoading }] = eventApi.useRemoveEventMutation();
  const handleDelete = async () => { await remove({ id }).unwrap(); onClose(); };
  return (
    <Backdrop onClick={onClose}>
      <Modal onClick={e=> e.stopPropagation()}>
        <div style={{fontWeight:700}}>Удалить мероприятие?</div>
        <div>Действие необратимо.</div>
        <Row>
          <Btn onClick={onClose}>Отмена</Btn>
          <Btn onClick={handleDelete} disabled={isLoading}>Удалить</Btn>
        </Row>
      </Modal>
    </Backdrop>
  );
};


